import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';

const STORAGE_KEY = 'app_lang';

const getStoredLanguage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && (stored === 'en' || stored === 'de')) return stored;
  } catch (e) {}
  return null;
};

const getBrowserLanguage = () => {
  const lang = navigator.language || navigator.userLanguage || '';
  if (lang.startsWith('de')) return 'de';
  if (lang.startsWith('en')) return 'en';
  return null;
};

// Default to German on first visit; once user picks a language in the switcher it is stored
const initialLanguage = getStoredLanguage() || 'de';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de }
  },
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch (e) {}
});

export default i18n;
export { STORAGE_KEY };
